import {
  DELETE_GRADE_START,
  DELETE_GRADE_SUCCESS,
  DELETE_GRADE_FAILED
} from '../../actionTypes/index.js'

import gradeAxios from '../../../../axios/gradeCriteria'
import { enqueueSnackbar } from '../../../actions/alert'
import { fetchGrades } from './fetch.js'

export const deleteGrade = gradeId => {
  return (dispatch, getState) => {
    dispatch(deleteGradeStart())
    gradeAxios
      .delete(`${gradeId}`)
      .then(response => {
        if (response.status === 200) {
          const filter = getState().gradeCriteria.filters

          dispatch(deleteGradeSuccess())
          dispatch(fetchGrades(filter))

          dispatch(
            enqueueSnackbar({
              message: 'Delete Grade Success',
              options: { variant: 'success' }
            })
          )
        }
      })
      .catch(error => {
        console.log(error, { ...error })
        dispatch(deleteGradeFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Delete Grade Failed',
            options: { variant: 'error' }
          })
        )
      })
  }
}

const deleteGradeStart = () => {
  return {
    type: DELETE_GRADE_START
  }
}

const deleteGradeSuccess = () => {
  return {
    type: DELETE_GRADE_SUCCESS
  }
}

const deleteGradeFailed = () => {
  return {
    type: DELETE_GRADE_FAILED
  }
}
